import React, { useContext } from "react";
import { useDriverHHM } from "../HouseholdContext/DriverHHMContext";

const OverviewSection = ({ requestContext, endorsementType }) => {
  var changeContext = useContext(requestContext);

  var driverHHMContext = useDriverHHM();
  var driverHHM = driverHHMContext.driverHHM;

  console.log("CompTra", driverHHM?.componentTracker);

  // console.log("Etype",endorsementType);

  return (
    <div
      className="row justify-content-center my-3"
      style={{ paddingLeft: "5%", paddingRight: "5%" }}
    >
      <div className="col-12 text-center">
        <h4 className="fw-bold text-primary" style={{ display: "flex" }}>
          Overview
        </h4>
        <p
          className="fw-bold m-0"
          style={{ display: "flex", paddingBottom: "10px" }}
        >
          The following policy update(s) have been requested:
        </p>

        {endorsementType == "Change Address" && (
          <>
            <p className="m-0" style={{ display: "flex" }}>
              <span className="m-0 fw-bold text-start" style={{ width: "25%" }}>
                New Address
              </span>
              <span
                className="ms-4 text-primary fw-bold text-start"
                style={{ width: "75%" }}
              >
                {`${changeContext?.addressChangeClass?.newAddress?.homeAddress}`}{" "}
                <br />
                {`${changeContext?.addressChangeClass?.newAddress?.city},${
                  changeContext?.addressChangeClass?.newAddress?.aptNumber
                    ? " " +
                      changeContext?.addressChangeClass?.newAddress?.aptNumber
                    : ""
                } ${changeContext?.addressChangeClass?.policyState} ${
                  changeContext?.addressChangeClass?.newAddress?.zip
                }`}
              </span>
            </p>
          </>
        )}
        {driverHHM?.userInfo?.firstName && (
          <>
            <p className="m-0" style={{ display: "flex" }}>
              <span className="m-0 fw-bold text-start" style={{ width: "25%" }}>
                {driverHHM?.componentTracker == "Add HHM" ||
                driverHHM?.componentTracker == "Add Driver" ||
                driverHHM?.componentTracker == "Add Household Member"
                  ? "New"
                  : "Updated"}{" "}
                {driverHHM?.componentTracker == "Add HHM" ||
                driverHHM?.componentTracker == "Update HHM" ||
                driverHHM?.componentTracker == "Add Household Member" ||
                driverHHM?.componentTracker == "Update Household Member"
                  ? "Household Member"
                  : "Driver"}
              </span>
              <span
                className="ms-4 text-primary fw-bold text-start"
                style={{ width: "75%" }}
              >
                {driverHHM.userInfo?.middleInitial
                  ? driverHHM.userInfo.firstName +
                    " " +
                    driverHHM.userInfo.middleInitial +
                    ". " +
                    driverHHM.userInfo.lastName
                  : driverHHM.userInfo.firstName +
                    " " +
                    driverHHM.userInfo.lastName}
              </span>
            </p>
          </>
        )}
      </div>
    </div>
  );
};

export default OverviewSection;
